import { Link } from "react-router-dom";

export default function NotFound(){
    return(
        <div className="notFoundPage">
            <div className="notFoundPage_inner">
                <div className="notFoundContent">
                    <div className="iconBox">
                        <img src={process.env.PUBLIC_URL + "/image/rocket_icon.png"}/>
                    </div>
                    <span>404 Error</span>
                    <h4>
                        이 페이지를 표시할 수 없습니다.<br/>
                        나중에 다시 시도하세요.
                    </h4>
                    <Link to="/lightHouse" className="goMain">홈으로 돌아가기</Link>
                </div>
            </div>
        </div>
    )
}